import { render, staticRenderFns } from "./VerifyPayment.vue?vue&type=template&id=0b4ffb8e&"
import script from "./VerifyPayment.vue?vue&type=script&lang=js&"
export * from "./VerifyPayment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports